<template>
  <h1 class="text-xl text-center mt-4">404 Not Found</h1>
</template>

<script>
export default {};
</script>

<style>
</style>